<template>
<v-layout>
  
  <v-dialog
    v-model="loading"
    hide-overlay
    persistent
    width="300"
    >
    <v-card
      color="amber darken-4"
      dark
      >
      <v-card-text>
        Please stand by
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
          ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
  
  <v-col offset-md="1" md="10">
    
    <v-container grid-list-xl text-center>
      <v-layout wrap>
	<v-flex md8>
	  
          <v-card dark color="amber darken-4" class="elevation-10">
            <v-card-text>
              <span class="display-1 font-weight-medium">Sources store state </span>
              <br/>
              <span class="display-1 font-weight-thin">@ {{ report.reportDate }} (prod {{ prodName }})</span>
              <br/>
	      
              <v-overflow-btn
		v-model="prodName"
		class="my-2"
		:items="prods"
		label="Select prod server"
		target="#dropdown-example"
		color="amber darken-4"
		></v-overflow-btn>
            </v-card-text>
          </v-card>
	  
          <br/>
	  
          <v-card dark color="green" class="elevation-10">
            <v-card-text>
              <span class="display-1 font-weight-medium">Refresh </span>
              <br/>
	      
              <v-overflow-btn
		v-model="refreshRate"
		class="my-2"
		:items="refreshRates"
		label="Refresh interval"
		target="#dropdown-example"
		color="amber darken-4"
		></v-overflow-btn>
            </v-card-text>
          </v-card>
	  
	</v-flex>
	<v-flex md4>
	  
          <v-date-picker
            class="elevation-10"
            style="margin: 0"
            :reactive="reactive"
            v-model="wantedReportDate"
            color="amber darken-4"
            ></v-date-picker>
	  
	</v-flex>
      </v-layout>
    </v-container>
    
    <v-container text-center v-if="errorState">
      <v-card
	max-width="500"
	class="mx-auto"
	color="red"
	>
	<v-card-text>
          <span class="display-1 font-weight-medium">No data for this date</span>
          <br/>
          <br/>
          <v-icon>fa-exclamation</v-icon>
	</v-card-text>
      </v-card>
    </v-container>
    
    
    <v-card v-else>
      <v-card-title>
	Only missing
	<v-spacer></v-spacer>
	<v-text-field
          v-model="search"
          append-icon="fa-search"
          label="Search"
          single-line
	  color="red"
          hide-details
	  ></v-text-field>
      </v-card-title>
      
      <v-card-text>
	<v-data-table
	  :headers="headers"
	  :items="report.report"
	  :disable-pagination="booltrue"
	  :hide-default-footer="booltrue"
	  :search="search"
	  >
	  
	  <template v-slot:item.files.missing="{ item }">
	    <Indicator :expected="item.files.expected" :available="item.files.available"></Indicator>
	  </template>
	</v-data-table>
      </v-card-text>
    </v-card>
    
    
    
  </v-col>
  
</v-layout>
</template>

<script>
import { config } from '../config';

import Indicator from './Indicator.vue';

export default {
    components: {
	Indicator
    },
    data: () => ({
        reactive: true,
        loading: true,
        fixedHeader: true,
        report: {},
        errorState: false,
        prods: config.prods,
        prodName: config.prods[0],
        wantedReportDate: new Date().toISOString().substr(0, 10),
        refreshRates: config.refreshRates,
        refreshRate: 0,
        timer: 0,
	booltrue: true,
	search: '',
	headers: [
            { text: 'Name', value: 'name' },
            { text: 'Expected files', value: 'files.expected' },
            { text: 'Delivered files', value: 'files.available' },
            { text: 'Missing', value: 'files.missing' },
	],
    }),
    
    watch: {
        prodName() {
            this.loadData();
        },
	
        wantedReportDate() {
            this.timer = 0;
            this.refreshRate = 0;
            this.loadData();
        },
	
        refreshRate() {
            this.wantedReportDate = new Date().toISOString().substr(0, 10);
            this.loadInterval();
            if (this.refreshRate === 0) {
                clearInterval(this.timer);
            }
        },
    },
    
    created() {
        this.loadData();
        this.loadInterval();
    },
    
    methods: {
        loadData() {
            this.loading = true;
	    
            const url = `${config.baseUrl}sources?prodname=${this.prodName}&date=${this.wantedReportDate}`;
	    
            this.$http.get(url, { auth: this.$store.getters.auth }).then((res) => {
                this.report = res.data;	
                this.loading = false;
                this.errorState = false;
		
		this.report.report.forEach(r => {
		    r.files.missing = r.files.expected - r.files.available;
		});
            }).catch((err) => {
		console.log(err);
                this.errorState = true;
                this.loading = false;
            });
        },
	
        loadInterval() {
            if (this.refreshRate !== 0) {
                this.timer = setInterval(this.loadData, this.refreshRate * 1000);
            }
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
